import * as React from 'react';
import { TooltipIcon } from '@grandvisionhq/common';
import DeliveryIndicatorModal from '../components/DeliveryIndicatorModal.js';
import { useDeliveryIndicator } from '../../../contexts/DeliveryIndicator/context.js';

const DeliveryIndicatorModalContainer = ()=>{
    const { deliveryInfo  } = useDeliveryIndicator();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const onModalOpen = React.useCallback(()=>{
        setIsModalOpen(true);
    }, [
        setIsModalOpen
    ]);
    const onModalClose = React.useCallback(()=>setIsModalOpen(false)
    , [
        setIsModalOpen
    ]);
    if (!deliveryInfo) return null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TooltipIcon, {
        id: "delivery-indicator-modal-toggle",
        onClick: onModalOpen
    }), /*#__PURE__*/ React.createElement(DeliveryIndicatorModal, {
        deliveryInfo: deliveryInfo,
        isModalOpen: isModalOpen,
        onModalClose: onModalClose
    }));
};

export { DeliveryIndicatorModalContainer };
//# sourceMappingURL=DeliveryIndicatorModal.js.map
